module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list"
  }, [_c('ul', _vm._l((_vm.relvantNewsData), function(article) {
    return _c('li', {
      key: article.id,
      staticClass: "flex flex-main-justify",
      on: {
        "click": function($event) {
          return _vm.goPath(article)
        }
      }
    }, [
      [_c('div', {
        staticClass: "info"
      }, [_c('div', {
        class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : article.imageUrl ? "min_height" : "" ]
      }, [(article.type === 'subject') ? _c('span', {
        staticClass: "tag_label_2"
      }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle))]), _vm._v(" "), _c('div', {
        staticClass: "flex-default date",
        staticStyle: {
          "justify-content": "flex-start"
        }
      }, [_c('div', {
        staticClass: "tag ellipsis"
      }, [(article.type != 'subject') ? _c('span', {
        staticClass: "tag-red",
        domProps: {
          "innerHTML": _vm._s(article.tags)
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(article.source)
        }
      })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]), _vm._v(" "), (article.imageUrl && article.imageUrl.length > 0) ? _c('div', {
        staticClass: "thumbnail",
        style: ({
          backgroundImage: 'url(' + article.imageUrl[0] + ')'
        })
      }, [_c('i', {
        class: [article.type + '-icon']
      })]) : _vm._e()]
    ], 2)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccf1485e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/com-list.vue
// module id = 865
// module chunks = 2